import * as React from 'react';
import { Icon, Panel, PanelBody, PanelHeader, PanelRow } from '@teamsnap/teamsnap-ui';
import Member from '../../models/member';
import { DateService, DateFormat } from 'frontend-toolkit';
import ContactInfo from '../../components/member/contact-info';
import EmailInfo from '../../components/member/email-info';
import PhoneNumberInfo from '../../components/member/phone-number-info';
import AddressInfo from '../../components/member/address-info';

export interface Props {
  member?: Partial<Member>;
}

const MemberInfo: React.FunctionComponent<Props> = ({ member }) => {
  const date = member?.birthdate ? new Date(member?.birthdate) : new Date();
  const hasNoMemberData =
    !member?.gender &&
    !member?.birthdate &&
    !member?.gender &&
    member?.emailAddresses?.length === 0 &&
    member?.phoneNumbers?.length === 0 &&
    member?.addresses?.length === 0;

  return (
    <Panel>
      <PanelHeader mods="u-textBold">About</PanelHeader>
      <PanelBody>
        <PanelRow>
          {hasNoMemberData ? (
            <div className="u-spaceBottomSm">There is no information about this member.</div>
          ) : (
            <>
              {member?.gender && (
                <div data-testid="member-gender" className="u-spaceBottomSm">
                  <Icon name="user" mods="u-spaceRightSm u-colorGrey" />
                  <span>{member?.gender}</span>
                </div>
              )}
              {member?.birthdate && (
                <div data-testid="member-birthdate" className="u-spaceBottomSm">
                  <Icon name="schedule" mods="u-spaceRightSm u-colorGrey" />
                  <span className="u-padTopSm">
                    <time dateTime={DateService.dateToString(date, DateFormat.YYYY_MM_DD)}>
                      {DateService.dateToString(date, DateFormat.LONG_DATE)}
                    </time>
                  </span>
                </div>
              )}
              {member?.emailAddresses?.length > 0 && (
                <div data-testid="member-emailAddresses">
                  {member?.emailAddresses?.map((emailAddress) => (
                    <EmailInfo key={`email-${emailAddress.id}`} emailAddress={emailAddress} />
                  ))}
                </div>
              )}
              {member?.phoneNumbers?.length > 0 && (
                <div data-testid="member-phoneNumbers">
                  {member?.phoneNumbers?.map((phoneNumber) => (
                    <PhoneNumberInfo key={`phone-number-${phoneNumber.id}`} phoneNumber={phoneNumber} />
                  ))}
                </div>
              )}
              {member?.addresses?.length > 0 && (
                <div data-testid="member-addresses">
                  {member?.addresses?.map((address) => (
                    <AddressInfo key={`address-${address.id}`} address={address} />
                  ))}
                </div>
              )}
            </>
          )}
        </PanelRow>
      </PanelBody>
      <PanelHeader mods="u-textBold" style={{ borderTop: '1px solid #d6d6d6' }}>
        Contacts
      </PanelHeader>
      <PanelBody>
        {member?.contacts?.length > 0 ? (
          <>
            {member?.contacts.map((contact) => (
              <PanelRow key={`contact-${contact.id}`}>
                <ContactInfo contact={contact} />
              </PanelRow>
            ))}
          </>
        ) : (
          <PanelRow>
            <div className="u-spaceBottomSm">There are no contacts for this member.</div>
          </PanelRow>
        )}
      </PanelBody>
    </Panel>
  );
};

export default MemberInfo;
